import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {normalizeSpeedTestDomainUrl} from "./speedTestDomainUrl";

declare var ko: any;

export class speedTestCruxDomainConfigEdit_template extends vnTemplate{

    public groupField: filterDropdown_template;
    public typeField: filterDropdown_template;

    protected getTemplateHtml(): string{

        return `
            <div class="form-header">
                <strong class="form-title icon i-speed">
                    <!-- ko ifnot: isEdit -->
                    Add Domain Configuration
                    <!-- /ko -->
                    <!-- ko if: isEdit -->
                    Edit Domain Configuration
                    <!-- /ko -->
                </strong>
                
                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close"  type="button"></button>
            </div>
            <div class="w-form-body" id="view-results">
            
                <div class="form-body">
                    <!-- ko if:isEdit() -->
                    <div class="form-group" >
                        <span class="form-label icon i-user" data-bind="text: domainName"></span>
                    </div>
                    <!-- /ko -->
                    <!-- ko ifnot:isEdit() -->                
                    <div class="form-group">
                        <label for="domainName" class="form-label">Domain Name</label>
                        <input id="domainName" data-bind="value: domainName" type="text" class="input-text">
                    </div>
                    <!-- /ko -->
                </div>
                <div class="form-body full-width">
                    <div class="form-group">
                        <label for="typeField" class="form-label">Type</label>
                        ${ this.typeField.getHtmlBuild() }
                    </div>
                </div>
                <div class="form-body full-width">
                    <div class="form-group">
                        <label for="groupField" class="form-label">Industry</label>
                        ${ this.groupField.getHtmlBuild() }
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">
                    <!-- ko ifnot: isEdit -->
                    Create Domain Configuration
                    <!-- /ko -->
                    <!-- ko if: isEdit -->
                    Update Domain Configuration
                    <!-- /ko -->
                </button>
            </div>
            
            <div id="delete-dialog" class="w-lightbox dark-theme">
                <div class="lightbox-content ">
                    
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Domain type override</h3>
                            <button data-bind="event: { click: onClickOverrideTypeDialogHide }" type="button" class="close-btn icon i-close"></button>
                        </div>
               
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This domain exists with a different Type</p>
                                <p class="form-text">Are you sure you want to override it?</p>   
                            </div>
                        </div>
            
                    <div class="form-footer">
                        <button data-bind="event: { click: onClickOverrideTypeDialogHide }" class="btn" type="button">Cancel</button>
                        <button data-bind="event: { click: onClickOverrideTypeConfirm }" class="btn highlight half" type="button">Confirm</button>
                    </div>
                </div>
                
            </div>
            `;
    }

    protected initPartial():void{

        this.groupField = new filterDropdown_template("groupField", this.getTemplateViewModel(), this.caller)
        this.typeField = new filterDropdown_template("typeField", this.getTemplateViewModel(), this.caller)
    }

    protected getTemplateName(): string{

        return "speedTestCruxDomainConfigEdit-form-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{

        return ["w-form", "margin-top"];
    }

    protected buildViewModel(): any{

        let that = this;

        return {

            id: ko.observable(''),
            domains: ko.observableArray([]),
            domainName: ko.observable(""),
            numberOfRuns: ko.observable(""),
            isEdit: ko.observable(false),
            onClickCancel: function(data, event) {
                that.onClickCancel();
            },
            onClickSave: function () {
                that.onClickSave();
            },
            onClickOverrideTypeDialogHide: function(data, event){

                that.onClickOverrideTypeDialogHide();
            },
            onClickOverrideTypeConfirm: function(data, event){

                that.onClickOverrideTypeConfirm();
            },
        };
    }

    public getViewModelForRequest(): Object{

        return {

            id: this.getTemplateViewModel().id,
            domainName: this.getTemplateViewModel().domainName,
            type: this.getTemplateViewModel().typeField.selectedOption,
            group: this.getTemplateViewModel().groupField.selectedOption,
        };
    }

    protected onClickSave() {

        if (this.getTemplateViewModel().isEdit() === false) {
            // Normalize before checking an existing domain for a type change.
            this.getTemplateViewModel().domainName(normalizeSpeedTestDomainUrl(this.getTemplateViewModel().domainName()));
            if (this.validateTypeChange()) {

                this.caller.save();
            }else {

                this.toggleOverrideTypeDialogVisibility();
            }
        }else {

            this.caller.save();
        }

    }

    protected onClickCancel(): void{

        this.caller.cancel();
    }

    public setId(id){

        this.getTemplateViewModel().id(id);
        this.getTemplateViewModel().isEdit(true);
    }

    public setDomainName(domainName){

        this.getTemplateViewModel().domainName(domainName);
    }

    public setGroup(group): void {

        this.groupField.setSelectedOption(group.id);
    }

    public setGroups(items: Array<any>): void {

        this.groupField.setOptions(items);
    }

    public setType(type): void {

        if (type != null) {

            this.typeField.setSelectedOption(type.id);
        }
    }

    public setTypes(items: Array<any>): void {

        this.typeField.setOptions(items);
    }

    public setDomains(domains: Array<any>): void {

        this.getTemplateViewModel().domains(domains);
    }

    protected validateTypeChange() {

        for (let domain of this.getTemplateViewModel().domains()){

            if (domain.domain == this.getTemplateViewModel().domainName() && domain.type.id != this.getTemplateViewModel().typeField.selectedOption()) {

                return false;
            }
        }

        return true;
    }

    protected onClickOverrideTypeConfirm(): void{

        this.toggleOverrideTypeDialogVisibility();
        this.caller.save();
    }

    public onClickOverrideTypeDialogHide() {

        this.toggleOverrideTypeDialogVisibility();
    }

    public toggleOverrideTypeDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/speedTestCruxDomainConfigEdit_template.ts